/**
 * authLanding.component.tsx
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

import { Alert } from "@mui/material";

import { AuthContext } from "./auth.context";

import { authServiceFactory } from "../services/auth.service";

export function AuthLandingContainer(): React.ReactElement<any, any> {
  const authContext = React.useContext<AuthContext>(AuthContext);
  const [missingToken, setMissingToken] = React.useState<boolean>(false);
  const [success, setSuccess] = React.useState<boolean>(false);
  const [errMsg, setErrMsg] = React.useState<string>("");
  const location = useLocation();
  const match = useParams<{token?: string}>();

  const searchParams = new URLSearchParams(location.search);
  const token = match.token || searchParams.get("token") || searchParams.get("code");

  React.useEffect(function () {
    if (!token) {
      setMissingToken(true);
      return;
    }
    const authService = authServiceFactory();
    authService.claimOneTimeToken(token).then(() => {
      return authService.getAccountMemberships(true);
    }).then(() => {
      return authContext.finishedLogin();
    }).then(() => setSuccess(true), err => {
      console.error("Error claiming token:", err);
      setErrMsg("Failed authenticating: " + (err as Error).message);
    });
  }, []);

  if (success) {
    return <Navigate to="/group" />;
  }
  return <section className="auth-landing-container">
    { errMsg && <Alert severity="error">{errMsg}</Alert> }
    { missingToken && <Alert severity="error">No authentication data provided</Alert>}
  </section>;
}
